import _slicedToArray from "/home/runner/work/products-v2/products-v2/products-v2/ecommerce/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import React from 'react';
import useChat from "../../hooks/useChat";
import { ClassNames } from "../../types";
var styles = {
  wrapper: {
    fontFamily: 'intercom-font, "Helvetica Neue", "Apple Color Emoji", Helvetica, Arial, sans-serif',
    color: 'white',
    fontSize: '16px',
    lineHeight: 1.5,
    WebkitTextSizeAdjust: '100%',
    WebkitFontSmoothing: 'antialiased'
  },
  launcher: {
    position: 'fixed',
    // z-index is 1 more than Intercom's actual launcher as when the real widget loads
    // it might not initially reflect the fake icon's current state (open/closed)
    zIndex: 2147483004,
    padding: '0 !important',
    margin: '0 !important',
    border: 'none',
    bottom: '20px',
    right: '20px',
    maxWidth: '48px',
    width: '48px',
    maxHeight: '48px',
    height: '48px',
    borderRadius: '50%',
    cursor: 'pointer',
    boxShadow: '0 1px 6px 0 rgba(0, 0, 0, 0.06), 0 2px 32px 0 rgba(0, 0, 0, 0.16)',
    transition: 'transform 167ms cubic-bezier(0.33, 0.00, 0.00, 1.00)',
    boxSizing: 'content-box'
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '48px',
    height: '48px',
    transition: 'transform 100ms linear, opacity 80ms linear'
  },
  logo: {
    transform: 'rotate(0deg) scale(1)'
  },
  close: {
    transform: 'rotate(-60deg) scale(0)'
  }
};
var Intercom = function Intercom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333333' : _ref$color,
    _ref$containerClass = _ref.containerClass,
    containerClass = _ref$containerClass === void 0 ? ClassNames.container : _ref$containerClass;
  var _useChat = useChat({
      loadWhenIdle: true
    }),
    _useChat2 = _slicedToArray(_useChat, 2),
    state = _useChat2[0],
    loadChat = _useChat2[1];
  if (state === 'complete') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    style: _objectSpread({}, styles.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    "aria-label": "Load Chat",
    "aria-busy": "true",
    "aria-live": "polite",
    onClick: function onClick() {
      return loadChat({
        open: true
      });
    },
    onMouseEnter: function onMouseEnter() {
      return loadChat({
        open: false
      });
    },
    style: _objectSpread(_objectSpread({}, styles.launcher), {}, {
      background: color
    })
  }, /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread(_objectSpread({}, styles.icon), styles.logo), {}, {
      opacity: state === 'initial' ? 1 : 0
    })
  }, /*#__PURE__*/React.createElement("svg", {
    height: "24px",
    width: "24px",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 28 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z"
  }))), /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread(_objectSpread({}, styles.icon), styles.close), {}, {
      opacity: state === 'initial' ? 0 : 1,
      transform: state === 'initial' ? 'rotate(-30deg)' : 'rotate(0deg)'
    })
  }, /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z",
    fill: "white"
  })))));
};
export default Intercom;